import React from 'react'
import SupportInfo from './SupportInfo';
import { Container } from '@material-ui/core';

const DownloadStarted = ({reset, resourceTitle}) => {
    return (
        <Container className="digital-center-content">
			<div className="thanks-downloading">
	        <h4>Thanks for downloading:</h4>
	        <h5>"{resourceTitle}"</h5>
	        <p>Files you've downloaded are automatically saved in your Downloads folder unless otherwise specified.</p>
	        <SupportInfo />
			<a href="javascript:void" onClick={reset} className="back-to-digital-download"><span></span>Go back to Digital Downloads</a>
	        </div>
		</Container>
    )
}

export default DownloadStarted;